export default function toStringValues<T extends Record<string, any>>(
  anEnum: T
): Array<T[keyof T]> {
  return Object.keys(anEnum).map((key) => anEnum[key] as T[keyof T])
}
